import { CtrlType } from "@yuigoto/ctrl";

export const ResetPasswordControl = [
  {
    name: "email",
    label: "E-Mail (insira um e-mail válido)",
    type: CtrlType.EMAIL,
    placeholder: "mail@mail.com",
    required: true,
    value: "",
    emailMessage: "Endereço de e-mail inválido",
    requiredMessage: "Este campo é obrigatório"
  }
];
